import { isDefined } from '@sgme/fp';
import { type ChangeEvent, Fragment, type ReactElement } from 'react';

type TargetAccumulatorToggleBaseProps = string;

interface TargetAccumulatorToggleProps<T> {
  name: string;
  identifier: string;
  values: readonly T[];
  selectedValue: T;
  onChange: (value: T) => void;
  formatValue?: (value: T) => string;
}

export function TargetAccumulatorSwitch<T extends TargetAccumulatorToggleBaseProps>({
  name,
  identifier,
  values,
  selectedValue,
  onChange,
  formatValue,
}: TargetAccumulatorToggleProps<T>): ReactElement {
  function getFormattedValue(value: T): string {
    if (isDefined(formatValue)) {
      return formatValue(value);
    }

    return value;
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>): void {
    const value = values.find((value) => value === event.target.id?.replace(`-${identifier}`, ''));

    if (isDefined(value)) {
      onChange(value);
    }
  }

  return (
    <div className="d-flex flex-column w-100">
      <div className="btn-group btn-group-toggle btn-group-sm">
        {values.map((value) => (
          <Fragment key={value}>
            <input
              className="btn-check"
              type="radio"
              name={`${name}-${identifier}`}
              id={`${value}-${identifier}`}
              value={value}
              checked={selectedValue === value}
              onChange={handleChange}
            />
            <label
              className="btn btn-toggle-primary w-50"
              htmlFor={`${value}-${identifier}`}
              data-e2e={`way-${value}-label`}
              data-e2e-way-type={selectedValue === value ? 'active' : undefined}
            >
              {getFormattedValue(value)}
            </label>
          </Fragment>
        ))}
      </div>
    </div>
  );
}
